const triggerDownload = (url: string, fileName?: string) => {
  const a = window.document.createElement('a')
  a.style.display = 'none'
  a.href = url
  a.setAttribute('download', fileName || '')

  window.document.body.appendChild(a)

  a.click()

  window.document.body.removeChild(a)
}

export const downloadBlob = async (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob)

  triggerDownload(url, fileName)

  URL.revokeObjectURL(url)
}

// Triggering multiple downloads at the same time leads to race conditions
const download = (...urls: string[]) => {
  let index = 0
  const timer = setInterval(() => {
    triggerDownload(urls[index])

    index += 1

    if (index >= urls.length) {
      clearInterval(timer)
    }
  }, 1000)
}

export default download
